import { get } from "lodash";
import { denormalize } from "normalizr";
import { referralSource as referralSourceSchema } from "../../../api/schema";

export default state => {
  try {
    const referralSource = get(state, `factoring.referral_source.ids`, []);

    const denormalized = denormalize(
      { referralSource },
      { referralSource: [referralSourceSchema] },
      state.entities
    );

    const items = [...(denormalized.referralSource || [])].sort((a, b) =>
      get(a, "name", "")
        .toUpperCase()
        .localeCompare(get(b, "name", "").toUpperCase())
    );

    return {
      ...get(state, `factoring.referral_source`, {}),
      items
    };
  } catch (err) {
    return {
      ...get(state, `factoring.referral_source`, {}),
      items: []
    };
  }
};
